module.exports = __webpack_public_path__ + "static/media/approveCardOrderCancellation.af50133e.svg";